module.exports = __webpack_public_path__ + "img/5cirPat.e73842ad.png";